import React from 'react';
import './Reviews.css';
import Popup from '../Popup/Popup'
import Vera from '../../img/reviews/Vera.jpg'
import Szczepansky from '../../img/reviews/Szczepansky.jpg';
import Goranov from '../../img/reviews/Goranov.jpg';
import Familonidis from '../../img/reviews/Familonidis.jpg';
import Moronta from '../../img/reviews/Moronta.jpg';
import Prabu from '../../img/reviews/Prabu.jpg';
import stars from '../../img/main/stars.png';
import quotes from '../../img/reviews/quotes.svg';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class Reviews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviews: [
        {
          id: 4,
          show: true,
          photo: Vera,
          name: 'Nelson Alvarez Vera',
          title: `This event in particular between career track and pro track was very demanding, because each one have a great content to follow, even in those days I was working in my job, but overall I appreciate that many professionals and experts share them knowledge and the enormous effort from Geekle team to make this event happen in the best way possible.`,
        },
        {
          id: 2,
          show: true,
          photo: Szczepansky,
          name: 'Bart Szczepansky',
          title: `I loved it! I wish there were more events like this and I wish it was promoted even better, so that more engineers and architects could join the summit. Also I was pleasantly impressed that among the organizing team there were so many Ukrainians! I'm feeling very proud of them! Слава Україні!`,
        },
        {
          id: 3,
          show: true,
          photo: Goranov,
          name: 'Vasil Goranov',
          title: `Very cool format. The talks were mostly half an hour which is the perfect length in my opinion. Good and interesting topics presented by awesome people. The organisation was on the required level and I didn't experience any difficulties. The schedule was easy to understand and work with. The girls were charming and really did their best to keep things together. Thank you for the wonderful experience.`,
        },
        {
          id: 1,
          show: true,
          photo: Familonidis,
          name: 'Kostas Familonidis',
          title: `It was an awesome initiative that I enjoyed, especially the positive attitude from all presenters and the host. I gathered valuable information that help me to follow the latest trends in the industry. Please keep up the good job that you are doing.`,
        },
        {
          id: 5,
          photo: Moronta,
          name: 'Wilson Tineo Moronta',
          title: `The Worldwide Software Architecture Summit was an excellent event that gave me the opportunity to learn a lot about software architecture, principally related to SaaS application and how to architecture for the cloud.`,
        },
        {
          id: 6,
          show: true,
          photo: Prabu,
          name: 'Prabu Varadharajalu Sivakumar',
          title: `Thoroughly blessed to be a part of this event. Had great opportunity to learn from Industry Experts. Though there are technical glitches, the show went on. There was always a back up process and very thoughtful insights. I’ve enrolled to all the 20 sessions in 2021. Can’t wait to learn from every track.`,
        },
      ]
    }
  }

  renderReviews(item, i) {
    return (
      <div className="reviews_item_wrap" key={`reviews_item-${i}`}>
        <div className='reviews_item'>
          <div className='reviews_item-content'>
            <img className='reviews_quotes' src={quotes} alt="" />
            {item.show && <div className='reviews_title'>
              {item.title.substring(0, 130)}...<Popup desc={item.title} title={item.name} key={i} />
            </div>}
            {!item.show && <div className='reviews_title'>
              {!item.show && <p>{item.title}</p>}
            </div>}
          </div>
          <div className='reviews_item-info'>
            <img className='reviews_photo' src={item.photo} alt="" />
            <div className="reviews_item_name_block">
              <p className="reviews_item_name">{item.name}</p>
              <img className="reviews_stars" src={stars} alt="" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="reviews black" id='reviews'>
        <div className='container reviews_wrap'>
          <h3>What <span className='title_gradient'>people</span> say</h3>
          <div className="review_block review_block--pc">
            {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
          </div>
          <div className="review_block review_block--mob">
            <Carousel showThumbs={false} showStatus={false} swipeable emulateTouch infiniteLoop>
              {this.state.reviews.map((item, i) => this.renderReviews(item, i))}
            </Carousel>
          </div>
        </div>
      </div>
    )
  }
}